// Components
import GuestNavbar from "../../Components/Guest/Components/GuestNavbar";

// Other
import React from "react";

const Landingpage = () => {
  return (
    <>
      <GuestNavbar page="landing-page" />
      <section className="font-brand w-80 flex flex-col justify-center absolute text-center top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <h1>Landing Page</h1>
      </section>
    </>
  );
};

export default Landingpage;
